export default {
setting: {
  wholeNumMessage: "Hanya angka bulat",
  profileAuthSetting: "Pengaturan Otentikasi Profil",
  logInOutSetting: "Pengaturan Masuk/Keluar",
  autoLogout: "Logout Otomatis",
  unsuccessfulLoginAttempt: "Percobaan Login Gagal",
  unsuccessfulLoginLockPeriod: "Periode Kunci Login Gagal",
  passCriteriaSetup: "Pengaturan Kriteria Kata Sandi",
  passLength: "Panjang Kata Sandi",
  noUniquePassRequired: "Tidak Perlu Kata Sandi Unik",
  maxPassAge: "Usia Kata Sandi Maksimal",
  acceptableRangeOfChars: "Rentang Karakter yang Diterima",
  upperCase: "Huruf Kapital",
  lowerCase: "Huruf Kecil",
  numbers: "Angka",
  specialChars: "Karakter Khusus",
  uniqueSymbols: "Simbol Unik",
  loadingData: "Memuat Data",
  currency: "Mata Uang",
  codeActivationTime: "Waktu Aktivasi Kode",
  changeGlobalSetting: "Ubah Pengaturan Global",
  globalSetting: "Pengaturan Global",
  generalSetting: "Pengaturan Umum",
  hour: "Jam",
  days: "Hari",
  minutes: "Menit",
  perDay: "Per Hari",
  perHour: "Per Jam",
  customised: "Disesuaikan",
  areaUnit: "Satuan Luas",
  weightUnit: "Satuan Berat",
  minimumPwdLen: "Panjang Kata Sandi Minimum",
  otpPlaceholder: "Masukkan OTP",
  generateOTP: "Hasilkan OTP",
  smallFarm: "Perkebunan Kecil",
  inclusive: "Inklusif",
  from: "Dari",
  to: "Sampai",
  mediumFarm: "Perkebunan Menengah",
  largeFarm: "Perkebunan Besar",
  requiredMessage: "Wajib Diisi",
  nonNegativeMessage: "Tidak boleh negatif",
  fieldToGreaterThanFrom: "Kolom 'Sampai' harus lebih besar dari 'Dari'",
  fieldToGreaterThanFromMedium: "Kolom 'Sampai' harus lebih besar dari 'Dari'",
  fieldToGreaterThanMediumTo: "Kolom 'Sampai' harus lebih besar dari 'Sampai (Menengah)'",
  unsuccessful_login_attempts_value_type: "Per jam",

  farmSettings: "Pengaturan Perkebunan",
  profileSettings: "Pengaturan Profil",
  enterpriseSettings: "Pengaturan Perusahaan",
  coffeeSettings: "Pengaturan Kopi",
},
}